const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]'),
  addToCartContainer: document.querySelector('.addtocart-container'),
  addToCartCTA: document.querySelector('.addtocart-container')
};

const mediaJSON = selectors.productMedia ? JSON.parse(selectors.productMedia.innerHTML) : [];
window.productMedia = mediaJSON;

class TemplateProductJS {
  constructor() {

    this.stickyATC();
    this.shortDescReadMore();
    // Custom code for product page goes here

    const productForm = document.querySelector('product-form form');
    if(productForm){
      const primarySubmit = productForm.querySelector('[name="add"]');
      document.querySelectorAll('[data-atc-out]').forEach(button => {
        button.addEventListener('click', (event) => {
          event.preventDefault();

          if (button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') {
            return;
          }

          button.classList.add('loading');
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('disabled', 'disabled');

          if (typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit(primarySubmit || undefined);
          } else if (primarySubmit) {
            primarySubmit.click();
          } else {
            productForm.submit();
          }
        });
      });
    }

    document.querySelector('.read_more')?.addEventListener('click', (e)=>{
      e.preventDefault();
      let currentTarget = e.target;
      if(currentTarget.closest('[data-readmorecontainer]').classList.contains('open')){
        Utility.toggleElement(currentTarget.closest('[data-readmorecontainer]'), 'close');
        currentTarget.textContent = "Learn more";
      }else{
        Utility.toggleElement(currentTarget.closest('[data-readmorecontainer]'), 'open');
        currentTarget.textContent = "Show Less";
      }
    });
  }

  shortDescReadMore() {
    document.fonts.ready.then(() => {
      document.querySelectorAll('[data-short-desc-readmore]').forEach(el => {
        const btn = el.querySelector('.short-desc-readmore-btn');
        if (!btn) return;

        if (el.scrollHeight > el.clientHeight + 2) {
          el.classList.add('short-desc--overflows');
        }

        btn.addEventListener('click', () => {
          el.classList.remove('short-desc--clamp', 'short-desc--overflows');
          btn.setAttribute('aria-expanded', 'true');
        });
      });
    });
  }

  stickyATC(){

    let stickyProductAction = document.querySelector('.product-sticky-container');
    if(stickyProductAction){
        let tabStickyContainer = document.querySelector('.logo-with-marquee');
        stickyProductAction.parentElement.style.minHeight = stickyProductAction.offsetHeight + 'px';
        if (tabStickyContainer != null || tabStickyContainer != undefined)
          tabStickyContainer.style.top = stickyProductAction.offsetHeight+'px';
        let fixedParent = stickyProductAction.closest('.product-details-wrapper').querySelector('product-form .addtocart-cta');
        
      window.addEventListener("scroll", event => {
        if(window.pageYOffset >= fixedParent.offsetTop) {
        if(!stickyProductAction.classList.contains('sticky-btn')) stickyProductAction.classList.add('sticky-btn');
        } else {
        if(stickyProductAction.classList.contains('sticky-btn')) stickyProductAction.classList.remove('sticky-btn');
        }
      }, { passive: true });
    }
  }
}



typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
